import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import routeConfiguration from '../../../../routeConfiguration';
import useScreenSize from '../../../../util/hooks/useScreenSize';
import { createResourceLocatorString } from '../../../../util/routes';
import IconUser from '../../../Icons/IconUser';
import NamedLink from '../../../Links/NamedLink/NamedLink';
import AvatarImg from './AvatarImg';

const NoSpotsRegisterCTAComponent = () => {
  const intl = useIntl();
  const theme = useTheme();
  const navigate = useNavigate();
  const { isMobile } = useScreenSize();

  return (
    <Stack alignItems="center" spacing={2} sx={{ maxWidth: 'sm', width: '100%', mx: 2 }}>
      <Chip label="BECOME HOST" />

      <Typography variant="h1">
        <FormattedMessage id="NoSpotsRegisterCTA.heading" />
      </Typography>

      <AvatarImg />

      <Typography textAlign="center" variant="body1">
        <FormattedMessage id="NoSpotsCTA.subHeading" />
      </Typography>

      <Button
        color="primary"
        fullWidth={isMobile}
        onClick={() => {
          navigate(
            createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}, intl.locale)
          );
        }}
        startIcon={<IconUser />}
        variant="contained"
      >
        <FormattedMessage id="SectionBecomeHost.encourageSignup" />
      </Button>

      <Typography sx={{ display: 'inline' }}>
        <FormattedMessage id="BookmarkPage.loginCTA" />
        <NamedLink
          name="SigninPage"
          style={{ underline: 'none', marginLeft: '1em', color: theme.palette.primary.main }}
        >
          <FormattedMessage id="BookmarkPage.loginLink" />
        </NamedLink>
      </Typography>
    </Stack>
  );
};

NoSpotsRegisterCTAComponent.displayName = 'NoSpotsRegisterCTA';
const NoSpotsRegisterCTA = memo(NoSpotsRegisterCTAComponent);

export default NoSpotsRegisterCTA;
